import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { colors } from '../../constants/colors';
import { styled } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';


const CheckboxCustom = styled(Checkbox)({

})

type Props = {
    label?: string;
    checked?: boolean;
    setChecked?: (status: boolean) => void;
    icon?: React.ReactNode;
    checkedIcon?: React.ReactNode;
    defaultChecked?: boolean;
    disabled?: boolean;
    indeterminate?: boolean;
}

const CheckBoxCustom: React.FC<Props> = (props: Props) => {
    const { checked, setChecked, icon, checkedIcon, label, defaultChecked, disabled, indeterminate } = props;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked && setChecked(event.target.checked);
    };

    return (
        <FormGroup>
            <FormControlLabel
                sx={{
                    color: colors.themeMainColor
                }}
                label={label}
                control={
                    <CheckboxCustom
                        defaultChecked={defaultChecked}
                        checked={checked}
                        disabled={disabled}
                        onChange={handleChange}
                        indeterminate={indeterminate}
                        inputProps={{ 'aria-label': 'controlled' }}
                        icon={icon || <CheckBoxOutlineBlankIcon sx={{ borderRadius: '6px', color: '#DDE1EB' }} />}
                        checkedIcon={checkedIcon || <CheckBoxIcon sx={{ borderRadius: '6px', color: colors.subPrimary }} />}
                    />} />
        </FormGroup>
    );
}

export default CheckBoxCustom